import { Box, Divider, Heading, HStack, Stack, Text } from '@chakra-ui/react';
import { map } from 'lodash-es';
import { headingTheme } from '@styles/component-themes/heading.theme';
import { textTheme } from '@styles/component-themes/text.theme';

export default function TextSection() {
  return (
    <HStack gap={12}>
      <Stack flex={1}>
        <Text fontWeight={600}>Text Variants</Text>
        <Divider />
        {map(textTheme.variants, (variantProps, variantName) => (
          <Box
            key={variantName}
            bgColor={variantProps.color?.includes('onPrimary') ? 'black' : 'initial'}
          >
            <Text {...variantProps}>{variantName}</Text>
          </Box>
        ))}
      </Stack>
      <Stack
        flex={1}
        alignSelf='flex-start'
        gap={12}
      >
        <Stack>
          <Text fontWeight={600}>Heading Sizes</Text>
          <Divider />
          {map(headingTheme.sizes, (sizeProps, sizeName) => (
            <Heading
              key={sizeName}
              {...sizeProps}
              textTransform='capitalize'
            >
              {sizeName} Heading Size
            </Heading>
          ))}
        </Stack>
        <Stack>
          <Text fontWeight={600}>Heading Variants</Text>
          <Divider />
          {map(headingTheme.variants, (variantProps, variantName) => (
            <Heading
              key={variantName}
              {...variantProps()}
              textTransform='capitalize'
            >
              {variantName} Heading Variant
            </Heading>
          ))}
        </Stack>
      </Stack>
    </HStack>
  );
}
